import type { SearchResponse } from '~/shared/interfaces/search'
import { ApiService } from '~/shared/api'

export class SearchService extends ApiService {
  public async getSearch(value: string): Promise<SearchResponse> {
    const res = await this.http.request<SearchResponse | null>({
      url: '/api/v1/yavagro/search',
      params: { q: value },
    })

    return res.data ?? {}
  }
}
